<template>
  <div class="container">

    <div class="columns is-desktop">

      <div class="column is-half is-offset-one-quarter">

        <figure class="image">
          <img src="../assets/logo-white.png" alt="HelixChart" style="max-width:400px;margin:3rem auto;padding: 0 15px;display: block;">
        </figure>

        <div class="card" style="margin-top:50px;">
          <div class="card-content">


              <h2 class="title is-2">Login</h2>


              <form v-on:submit.prevent="login">
                <b-field>
                    <b-input
                        type="email"
                        placeholder="Email"
                        icon="email"
                        v-model="email"
                        required>
                    </b-input>
                </b-field>


                 <b-field>
                      <b-input type="password"
                          placeholder="Password"
                          v-model="password"
                          icon="lock"
                          password-reveal
                          required>
                      </b-input>
                </b-field>

                <div class="field">
                  <p class="control">
                    <button @click="login" class="button is-success">
                      Login
                    </button>
                  </p>
                </div>

            </form>

            <div style="margin-top: 10px;">
                <p>
                  Don't have an account?
                  <router-link to="/sign-up">Create one!</router-link>
                </p>

                <p>
                  <a @click="resetPassword">Reset password</a>
                </p>
            </div>


          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.replace('projects');
          this.$toast.open({
            message: 'Successfully logged in!',
            position: 'is-bottom',
            type: 'is-success',
          });
        }, (error) => {
          this.$toast.open({
            message: 'Error logging in. Please check back later.',
            position: 'is-bottom',
            type: 'is-danger',
          });
        });
    },
    resetPassword() {
      if (!this.email) {
        this.$toast.open({
          message: 'Enter your email address to reset password.',
          position: 'is-bottom',
          type: 'is-danger',
        });
      } else {
        firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.$toast.open({
              message: 'Password reset email sent!',
              position: 'is-bottom',
              type: 'is-success',
            });
          }, (error) => {
            this.$toast.open({
              message: `Error: ${error.message}`,
              position: 'is-bottom',
              type: 'is-danger',
            });
          });
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue